import React from 'react';
import './PenziLegalLayout.css';

export function isPenziDomain() {
    const hostname = window.location.hostname.toLowerCase();
    return hostname === 'penzi-halisi.com' || hostname.endsWith('.penzi-halisi.com');
}

export default function PenziLegalLayout({ children }) {
    if (!isPenziDomain()) return <>{children}</>;

    return (
        <main className="penzi-legal-page">
            <div className="penzi-legal-site">
                <header className="penzi-legal-masthead">
                    <a className="penzi-legal-brand" href="/" aria-label="Penzi Halisi homepage">
                        <span className="penzi-legal-logo"><img src="/assets/img/phlogo.jpeg" alt="Penzi Halisi" /></span>
                        <span><span className="penzi-legal-name">Penzi Halisi</span></span>
                    </a>
                    {/* <a className="penzi-legal-back" href="/">Back to home</a> */}
                </header>
                <article className="penzi-legal-card">{children}</article>
                <nav className="penzi-legal-footer" aria-label="Legal pages">
                    <a href="/privacypolicy">Privacy Policy</a>
                    <a href="/termssandconditions">Terms and Conditions</a>
                </nav>
            </div>
        </main>
    );
}
